module.exports = __webpack_public_path__ + "static/media/text-allign-justify.ad9b116e.svg";